import React, { useContext, useEffect, useState, forwardRef, useImperativeHandle, useRef } from "react";
import { Bar, SidebarMenuProps } from "./bar";
import {
  SideBarMenuContextValue,
  SideBarMenuContext,
} from "./sidebar-menu-context-provider";
import { focusOnAnyBttnElement } from "./utils";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

export function SidebarMenu(props: SidebarMenuProps) {
  const { menuItems, headerItem, footerItem, accountPicker, className, screenSize, mainMenuItemloading } = props;
  const { selectedItemMainMenu, selectedItemSubmenu, setSelectedItemMainMenu, setSelectedItemSubmenu, setItemMainMenuWDataLoading, hideBar, setHideBar, showTopMenu, setShowTopMenu } = useContext<SideBarMenuContextValue>(SideBarMenuContext);
  const [selectSubmenuItemFromLoading, setSelectSubmenuItemFromLoading] = useState(false);
  const navigate = useNavigate();
  const { t } = useTranslation();

  useEffect(() => {
    setItemMainMenuWDataLoading(mainMenuItemloading)
  }, [mainMenuItemloading])

  // the duplicate state in the context can easily go stale, this effect "fixes" it
  // please refactor this away someday
  useEffect(() => {
    if (menuItems && selectedItemMainMenu) {
      setSelectedItemMainMenu(menuItems?.find(item => item.uniqueId === selectedItemMainMenu.uniqueId))
    }
  }, [JSON.stringify(menuItems)])

  useEffect(() => {
    if (selectedItemMainMenu && selectedItemMainMenu.subMenuItems && mainMenuItemloading !== selectedItemMainMenu.uniqueId) {
      if (screenSize !== 'lg') {
        focusFirstNotLgScreen();
      } else {
        handleSelectFirstChild();
      }
    } else if (selectedItemMainMenu && screenSize !== 'lg') {
      setHideBar(true);
    }
  }, [selectedItemMainMenu])


  useEffect(() => {
    if (screenSize === 'sm' && (hideBar || !selectedItemMainMenu) && !selectSubmenuItemFromLoading) {
      handleShowTopMenu()
    } else {
      setSelectSubmenuItemFromLoading(false)
    }
  }, [selectedItemSubmenu])

  const focusFirstNotLgScreen = () => {
    if (!hideBar) {
      setHideBar(true)
    }
    if (screenSize === 'sm') {
      setSelectSubmenuItemFromLoading(true)
    }
    handleSelectFirstChild()
  }

  const handleBackButton = () => {
    if (selectedItemMainMenu) {
      setHideBar(false)
    }
  }

  const handleShowTopMenu = () => {
    setShowTopMenu((prev) => !prev)
    if (showTopMenu && !selectedItemSubmenu) {
      setHideBar(false)
    }
    if (!showTopMenu && selectedItemSubmenu && selectedItemSubmenu.mainMenuItem) {
      if (selectedItemSubmenu.mainMenuItem?.uniqueId !== selectedItemMainMenu?.uniqueId) {
        setSelectedItemMainMenu(selectedItemSubmenu.mainMenuItem)
      }
      setHideBar(true)
    }

    if (selectedItemMainMenu) {
      if (selectedItemMainMenu.subMenuItems && !selectedItemSubmenu) {
        setSelectedItemMainMenu(undefined)
      } else if (!hideBar) {
        focusOnAnyBttnElement(selectedItemMainMenu?.uniqueId)
      } else {
        focusOnAnyBttnElement(selectedItemSubmenu!.uniqueId)
      }
    } else if (selectedItemSubmenu) {
      focusOnAnyBttnElement(selectedItemSubmenu.uniqueId)
    }
  }

  const handleSelectFirstChild = () => {
    if (selectedItemMainMenu?.subMenuItems) {
      const childInfo = { ...selectedItemMainMenu.subMenuItems[0], mainMenuItem: selectedItemMainMenu }
      setSelectedItemSubmenu(childInfo)
      setItemMainMenuWDataLoading(undefined)
      if (screenSize !== 'sm') {
        navigate(childInfo.to!)
      }
    }
  }

  if (screenSize === 'lg') {
    return (
      <div
        className={`navbar-main ${className || ""}`}
        data-testid="navbar-main"
      >
        <Bar
          key="navbar-main-lg"
          headerItem={headerItem}
          accountPicker={accountPicker}
          menuItems={menuItems}
          footerItem={footerItem}
          screenSize={screenSize}
        />
        {selectedItemMainMenu && (
          <Bar
            key={selectedItemMainMenu.uniqueId}
            menuItems={selectedItemMainMenu.subMenuItems}
            mainMenuItem={selectedItemMainMenu}
            mainMenuItemloading={mainMenuItemloading}
            screenSize={screenSize}
          />
        )}
      </div>
    );
  } else if (screenSize === 'md') {
    return (
      <div
        className={`navbar-main ${className || ""}`}
        data-testid="navbar-main"
      > {!hideBar &&
        <Bar
          key="navbar-main-md"
          headerItem={headerItem}
          accountPicker={accountPicker}
          menuItems={menuItems}
          footerItem={footerItem}
          screenSize={screenSize}
        />
        }
        {selectedItemMainMenu && hideBar &&
          <Bar
            key={selectedItemMainMenu.uniqueId}
            menuItems={selectedItemMainMenu.subMenuItems}
            mainMenuItem={selectedItemMainMenu}
            backButtonFn={handleBackButton}
            mainMenuItemloading={mainMenuItemloading}
            screenSize={screenSize}
          />
        }
      </div>
    )
  } else {
    return (
      <div>
        {showTopMenu && <div className={`navbar-top-main-small-screen ${className || ""}`}>
          <button data-testid='navbar-top-small-screen-button' aria-label={t('show_menu', 'Show Menu')} className="navbar-top-small-screen-button" onClick={handleShowTopMenu}>
            <img src='https://static.pokemon.com/images/menu-icon.svg' alt="" />
          </button>
          <div className="navbar-menu-logo-wrapper">
            <img className="navbar-menu-logo" src='https://static.pokemon.com/images/pokemon_logo.png' alt={t('pokemon_logo', 'Pokémon logo')} />
          </div>
        </div>}
        {!showTopMenu && !hideBar &&
          <div>
            <button data-testid='navbar-sm-screen-close-menu-button' className="navbar-menu-sm-screen-close-bttn" onClick={handleShowTopMenu}><img src='https://static.pokemon.com/images/times_solid.svg' alt={t('close_button', 'Close')} /></button>
            <Bar
              key="navbar-main-sm"
              headerItem={headerItem}
              accountPicker={accountPicker}
              menuItems={menuItems}
              footerItem={footerItem}
              className={"navbar-menu-sm-screen-main-menu"}
              screenSize={screenSize}
            />
          </div>
        }
        {selectedItemMainMenu && hideBar && !showTopMenu &&
          <div>
            <button data-testid='navbar-sm-screen-close-menu-button' className="navbar-menu-sm-screen-close-bttn" onClick={handleShowTopMenu}><img src='https://static.pokemon.com/images/times_solid.svg' alt={t('close_button', 'Close')} /></button>
            <Bar
              key={selectedItemMainMenu.uniqueId}
              menuItems={selectedItemMainMenu.subMenuItems}
              mainMenuItem={selectedItemMainMenu}
              backButtonFn={handleBackButton}
              screenSize={screenSize}
            />
          </div>
        }
      </div>
    )
  }
}
